// extracted by mini-css-extract-plugin
export var authorByLineTooltipTrigger = "by_fh";
export var authorBylineContainer = "by_ff";
export var authorPrefix = "by_fg";